<template>
  <div class="wt-dialog-container">
    <div>
      <wt-detail-form-section ref="formSection" :detail-form-data.sync="detailFormData" :detail-form.sync="detailForm">
        <template slot="id1" slot-scope="scope">
          <el-select v-model="detailFormData.id1" filterable :placeholder="scope.item.disabled ? '' : '请选择' + scope.item.name" :disabled="scope.item.disabled" @change="id1Change">
            <el-option v-for="(dataItem, dataIndex) in scope.item.data" :key="dataIndex" :label="dataItem.label"
                       :value="dataItem.value"></el-option>
          </el-select>
        </template>
        <template slot="id2" slot-scope="scope">
          <el-select v-model="detailFormData.id2" filterable :placeholder="scope.item.disabled ? '' : '请选择' + scope.item.name" :disabled="scope.item.disabled" @change="id2Change">
            <el-option v-for="(dataItem, dataIndex) in scope.item.data" :key="dataIndex" :label="dataItem.label"
                       :value="dataItem.value"></el-option>
          </el-select>
        </template>
        <template slot="orgId" slot-scope="scope">
          <el-select v-model="detailFormData.orgId" filterable :placeholder="scope.item.disabled ? '' : '请选择' + scope.item.name" :disabled="scope.item.disabled" @change="orgIdChange">
            <el-option v-for="(dataItem, dataIndex) in scope.item.data" :key="dataIndex" :label="dataItem.label"
                       :value="dataItem.value"></el-option>
          </el-select>
        </template>
        <template slot="isDeliveryEnabled">
          <el-switch
            v-model="detailFormData.isDeliveryEnabled"
            active-color="#13ce66"
            inactive-color="#f1f1f1"
            :active-value="0"
            :inactive-value="1">
          </el-switch>
        </template>
        <template slot="map">
          <div class="map-container" id="mapContainer"></div>
        </template>
        <template slot="address">
          <el-input v-model="detailFormData.address"><template slot="append"><el-button @click="toPosition">定位</el-button></template></el-input>
        </template>
      </wt-detail-form-section>
      <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SiteIndexEditPage',
  props: ['component-type', 'detailData'],
  isAutoComponent: true,
  data() {
    return {
      isSubmitLoading: false,
      formUpdateUrl: '/modules/site/siteUpdate',
      formAddUrl: '/modules/site/siteAdd',
      detailForm: {
        title: '新增站点',
        className: 'wt-section-long-content',
        elements: [
          { name: '物业总公司', key: 'id1', type: 'custom', required: true, disabled: true, data: [] },
          { name: '物业分公司', key: 'id2', type: 'custom', required: true, disabled: false, data: [] },
          { name: '项目部', key: 'orgId', type: 'custom', required: true, disabled: false, data: [] },
          { name: '社区',
            key: 'communityId',
            type: 'select',
            required: true,
            disabled: false,
            data: [],
            attr: { filterable: true }},
          { name: '户数',
            key: 'house',
            type: 'text',
            required: true,
            disabled: false,
            rules: [
              { validator: this.$wtValidator.ValidatorNotBlank, message: '户数不能为空', trigger: 'blur' },
              { validator: this.$wtValidator.ValidatorGreaterZeroInt, trigger: 'blur' }
            ] },
          { name: '站点名称',
            key: 'name',
            type: 'text',
            required: true,
            disabled: false,
            rules: [
              { validator: this.$wtValidator.ValidatorNotBlank, message: '站点名称不能为空', trigger: 'blur' }
            ] },
          { name: '是否开通投递功能', key: 'isDeliveryEnabled', type: 'custom', required: true, disabled: false, data: [] },
          { name: '站点位置',
            key: 'address',
            type: 'custom',
            required: true,
            disabled: false,
            rules: [
              { validator: this.$wtValidator.ValidatorNotBlank, message: '站点位置不能为空', trigger: 'blur' }
            ] },
          { name: '地图',
            key: 'map',
            type: 'customAll',
            required: false,
            disabled: false }]
      },
      detailFormButtons: {
        title: '新增站点',
        elements: [{ name: '提交', key: 'ADD', action: 'ADD', className: 'primary', hidden: this.componentType !== 'add' },
          { name: '提交', key: 'EDIT', action: 'EDIT', className: 'primary', hidden: this.componentType !== 'edit' },
          { name: '取消', key: 'CLOSE', action: 'CLOSE' }]
      },
      map: null,
      geocoder: null,
      marker: null,
      mapData: {
        address: '',
        pos: {}
      },
      detailFormData: {}
    }
  },
  created() {
    this.orgListSelect(1, 0)
    this.requestcommunityList()
    this.detailForm.title = this.componentType === 'edit' ? '编辑站点' : '新增站点'
    this.detailFormData = JSON.parse(JSON.stringify(this.detailData.row))
    this.initForm()
    if (this.detailData.row.id1) {
      this.orgListSelect(2, this.detailData.row.id1)
    }
    if (this.detailData.row.id2) {
      this.orgListSelect(3, this.detailData.row.id2)
    }
    if (this.componentType === 'edit' && this.detailData.row.latitude) {
      this.mapData.address = this.detailFormData.address
      this.mapData.pos = {
        lat: this.detailFormData.latitude,
        lng: this.detailFormData.longitude
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initMap()
    })
  },
  methods: {
    initForm() {
      if (this.detailData.parent) {
        if (this.detailData.parent.level * 1 > 1) {
          this.setFormItem('id2', 'disabled', true)
        }
        if (this.detailData.parent.level * 1 > 2) {
          this.setFormItem('orgId', 'disabled', true)
        }
      } else {
        this.setFormItem('id1', 'disabled', false)
        this.setFormItem('id2', 'disabled', false)
        this.setFormItem('orgId', 'disabled', false)
        this.$set(this.detailFormData, 'id1', '')
        this.$set(this.detailFormData, 'id2', '')
        this.$set(this.detailFormData, 'orgId', '')
      }
    },
    setFormItem(key, attr, attrVal) {
      const el = this.detailForm.elements.find(item => { return item.key === key })
      el[attr] = attrVal
    },
    id1Change(val) {
      this.detailFormData.id2 = ''
      this.detailFormData.orgId = ''
      this.orgListSelect(2, val)
    },
    id2Change(val) {
      this.detailFormData.orgId = ''
      this.orgListSelect(3, val)
    },
    orgIdChange() {},
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
      } else if (item.action === 'ADD') {
        this.onAdd()
      } else if (item.action === 'EDIT') {
        this.onSave()
      }
    },
    onAdd() {
      const that = this
      if (this.detailFormData.address && this.mapData.address !== this.detailFormData.address) {
        that.$message.warning('站点位置发生变化，请重新定位')
        return
      }
      this.$wtUtil.validateDetailFormsAndConfirm(this, '是否提交').then(() => {
        that.requestAdd()
      }).catch(() => {
      })
    },
    onSave() {
      const that = this
      if (this.detailFormData.address && this.mapData.address !== this.detailFormData.address) {
        that.$message.warning('站点位置发生变化，请重新定位')
        return
      }
      this.$wtUtil.validateDetailFormsAndConfirm(this, '是否提交').then(() => {
        that.requestUpdate()
      }).catch(() => {
      })
    },
    requestAdd() {
      const that = this
      this.detailFormData.latitude = this.mapData.pos.lat
      this.detailFormData.longitude = this.mapData.pos.lng
      this.$wtUtil.postFormData({
        url: this.formAddUrl,
        formData: this.detailFormData,
        isLoading: this.isSubmitLoading
      }).then(resp => {
        that.$message({ message: '保存成功', type: 'success' })
        that.$emit('on-dialog-action', 'close')
        this.$store.dispatch('removeBreadcrumb')
        this.$emit('on-dialog-action', 'refresh')
      })
    },
    requestUpdate() {
      const that = this
      this.detailFormData.latitude = this.mapData.pos.lat
      this.detailFormData.longitude = this.mapData.pos.lng
      this.$wtUtil.postFormData({
        url: this.formUpdateUrl,
        formData: this.detailFormData,
        isLoading: this.isSubmitLoading
      }).then(resp => {
        that.$message({ message: '保存成功', type: 'success' })
        that.$emit('on-dialog-action', 'close')
        this.$store.dispatch('removeBreadcrumb')
        this.$emit('on-dialog-action', 'refresh')
      })
    },
    requestcommunityList() {
      const ele = this.detailForm.elements.find(item => { return item.key === 'communityId' })
      this.$api.community.communityNoPageList({
        url: '/modules/community/communityNoPageList',
        method: 'post'
      }).then(res => {
        if (res.code === '0') {
          for (const item of res.data) {
            item.label = item.name
            item.value = item.id
          }
          ele.data = res.data
        }
      })
    },
    initMap() {
      this.map = new AMap.Map('mapContainer', { resizeEnable: true })
      this.geocoder = new AMap.Geocoder({})
      this.marker = new AMap.Marker({
        icon: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png',
        offset: new AMap.Pixel(-13, -30)
      })
      if (this.componentType === 'edit' && this.detailData.row.latitude) {
        this.toRegeoCode()
        this.toPosition()
      }
    },
    toRegeoCode() {
      const lnglat = [this.mapData.pos.lng, this.mapData.pos.lat]
      this.map.add(this.marker)
      this.marker.setPosition(lnglat)
    },
    toPosition() {
      const that = this
      if (!this.detailFormData.address) {
        that.$message.warning('请先输入站点地址')
        return
      }
      this.geocoder.getLocation(this.detailFormData.address, function(status, result) {
        console.log(status, result)
        if (status === 'complete' && result.geocodes.length) {
          that.mapData.address = that.detailFormData.address
          that.mapData.pos = result.geocodes[0].location
          that.marker.setPosition(result.geocodes[0].location)
          that.map.add(that.marker)
          that.map.setFitView(that.marker)
        } else {
          that.$message.error('根据地址查询位置失败')
        }
      })
    },
    orgListSelect(level, pid) {
      const ele1 = this.detailForm.elements.find(item => { return item.key === 'id1' })
      const ele2 = this.detailForm.elements.find(item => { return item.key === 'id2' })
      const ele3 = this.detailForm.elements.find(item => { return item.key === 'orgId' })
      this.$api.siteManage.org.orgListSelect({
        level: level,
        parentid: pid
      }).then(res => {
        for (const item of res.data) {
          item.label = item.name
          item.value = item.id
        }
        if (level === 1) {
          ele1.data = res.data
        }
        if (level === 2) {
          ele2.data = res.data
        }
        if (level === 3) {
          ele3.data = res.data
        }
      })
    }
  },
  beforeDestroy() {
    this.map && this.map.destroy()
  }
}
</script>
<style lang="scss" scoped>
  .map-container {
    margin-left: 180px;
    height: 500px;
  }
</style>
